/*----------------------------------
- DEPENDANCES
----------------------------------*/

// Npm
import React from 'react';
import { Switch as MantineSwitch } from '@mantine/core';

// App
import LegacyMantineProvider from './Provider';

/*----------------------------------
- TYPES
----------------------------------*/

export type Props = React.ComponentProps<typeof MantineSwitch>;

/*----------------------------------
- COMPONENT
----------------------------------*/
export default function Switch(props: Props) {
    return (
        <LegacyMantineProvider>
            <MantineSwitch {...props} />
        </LegacyMantineProvider>
    );
}
